export const getEmailTagDialogStyle = () => ({
  container: {
    lineHeight: '24px',
    '& .email-tag-view': {
      marginLeft: 0,
    },
  },
});
